import { formatPeriodDisplay, parsePeriod } from '../../utils/DateUtils'

/**
 * Null Object over "is a period selected?".
 *
 * A filter cell has to answer three questions about its value — what to label
 * the button, which year to open the grid on, and whether a clear affordance
 * belongs there. Answering each with its own `value ? ... : ...` is how the old
 * picker ended up with three pieces of state to keep in agreement. Here the
 * question is decided once, in `periodSelectionFrom`, and the answers follow
 * from the type.
 */
const EMPTY_LABEL = ' '

class SelectedPeriod {
    constructor(period) {
        this.period = period;
    }

    label() {
        return formatPeriodDisplay(this.period);
    }

    yearOr(_fallbackYear) {
        return this.period.year;
    }

    clearActionOr(clearAction) {
        return clearAction;
    }
}

class NoPeriodSelected {
    label() {
        return EMPTY_LABEL;
    }

    yearOr(fallbackYear) {
        return fallbackYear;
    }

    clearActionOr(_clearAction) {
        return null;
    }
}

const NO_PERIOD_SELECTED = new NoPeriodSelected()

/** Builds a selection from a "YYYY-MM" filter value, present or not. */
export const periodSelectionFrom = value => {
    const period = parsePeriod(value);
    return period ? new SelectedPeriod(period) : NO_PERIOD_SELECTED;
}

export { SelectedPeriod, NoPeriodSelected, NO_PERIOD_SELECTED }
